import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=fdfe09aa&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdfe09aa')) {
      api.createRecord('fdfe09aa', component.options)
    } else {
      api.reload('fdfe09aa', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=fdfe09aa&", function () {
      api.rerender('fdfe09aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20tEJVp73l7Q0/JS/comp/ImgFallback.vue"
export default component.exports